import axios from 'axios'
import {getAppVersion} from '@/tool';
import rum from '@/tool/rum';

// create an axios instance
const service = axios.create({
  baseURL: getAppVersion() === 'ZH' ? process.env.API_BASEURL_ZH : process.env.API_BASEURL,
  //baseURL: `//${location.hostname}/admin`, // api 的 base_url
  timeout: 10000 // request timeout
})

function objKeySort(obj) {
    var newkey = Object.keys(obj).sort();
    var newObj = {};
    for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]];
    }
    return newObj;
}


// request interceptor
service.interceptors.request.use(


  config => {
    // Do something before request is sent
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //localStorage.setItem('cg-session',"eyJhbGciOiJIUzUxMiIsImlhdCI6MTYyNTEwNzY3MCwiZXhwIjoxNjI1MjM3MjcwfQ.eyJ1c2VyX2lkIjoiMiJ9.FROyXPaqYcR2zF3P-B5kdII5UHUgPbQ07DtWjrkTUY9Xx09UL_3QdkfAAJXcCiXol78_Z3vmAA_LCACmB6WSuA")
    //config.headers['token'] = localStorage.getItem('cg-session');
    //console.log(config)
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    //Promise.reject(error)
  }
)

/**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
service.interceptors.response.use(
  response => {

    const { config } = response;
    const { url, params, data } = config;
    const status = response ? response.status : null;
    // rum网络请求成功上报
    rum.report('network', {
      url,
      params: params || data,
      status
    }, 1)
    //console.log('responseresponse', response);
    return response
    // if(response.data.code == 1002) {
    //   window.location.href = response.data.data.sso_login_callback_url;
    //   return response;
    // }else{
    //   return response
    // }
  },
  error => {
    console.error(error);
    const { config, response } = error;
    const { url, params, data } = config;
    const status = response ? response.status : null;
    // rum网络请求错误上报
    rum.report('network_err', {
      url,
      params: params || data,
      status,
      data: response ? response.data : null
    }, 2)
    if(error.message.indexOf('timeout') > -1){
      alert('error: Timeout！')
    }

    //return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/tool/request.js